module.exports = "../../app/cells/pages/landing_xray/index/hero_cell.rb";